import "@frontend/styles/components/slide-toggle.css";
import { on, off, fire } from "delegated-events";
import { slideToggle } from "@frontend/scripts/common/slide";

const handleToggle = async (e) => {
  if (e.type === "keyup" && e.keyCode !== 13) {
    return;
  }

  if (e.target.closest("[data-scroll]")) {
    return;
  }

  const trigger = e.target.closest("[data-slide-toggle]");

  if (!trigger) {
    return;
  }

  const target = document.getElementById(trigger.getAttribute("aria-controls"));

  if (!target) {
    return;
  }

  const otherTriggers = Array.from(
    document.querySelectorAll(`[data-slide-toggle][aria-controls="${trigger.getAttribute("aria-controls")}"]`),
  ).filter((x) => x !== trigger);

  if (trigger.getAttribute("aria-expanded") === "false") {
    trigger.setAttribute("aria-expanded", "true");
    otherTriggers.forEach((x) => x.setAttribute("aria-expanded", "true"));

    const holder = trigger.closest("[data-slide-toggle-holder]");

    if (holder) {
      holder.classList.add("is-active");
    } else {
      trigger.parentNode.classList.add("is-active");
      otherTriggers.forEach((x) => x.parentNode.classList.add("is-active"));
    }

    await slideToggle(target);

    fire(document.documentElement, "slidetoggle:open", { trigger });
  } else {
    slideToggle(target);
    trigger.setAttribute("aria-expanded", "false");
    otherTriggers.forEach((x) => x.setAttribute("aria-expanded", "false"));

    const holder = trigger.closest("[data-slide-toggle-holder]");

    if (holder) {
      holder.classList.remove("is-active");
    } else {
      trigger.parentNode.classList.remove("is-active");
      otherTriggers.forEach((x) => x.parentNode.classList.remove("is-active"));
    }

    fire(document.documentElement, "slidetoggle:close", { trigger });
  }
};

const handleOpenedDefault = () => {
  document.querySelectorAll("[data-slide-toggle-opened-default]").forEach((el) => {
    const trigger = el.closest("[data-slide-toggle]");
    const target = document.getElementById(trigger.getAttribute("aria-controls"));

    if (trigger && target) {
      trigger.setAttribute("aria-expanded", "true");
      target.classList.remove("hidden");
    }
  });
};

export default {
  init: () => {
    const clickArgs = ["click", "[data-slide-toggle]", handleToggle];

    off(...clickArgs);
    on(...clickArgs);

    handleOpenedDefault();
  },
};
